import React, { useState } from "react";
import styles from "./Timeline.module.css";
import early from "../../../assets/images/school_programmes/programmes/early.png";
import junior from "../../../assets/images/school_programmes/programmes/Junior.png";
import senior from "../../../assets/images/school_programmes/programmes/Senior.png";
import advanced from "../../../assets/images/school_programmes/programmes/Advanced.png";

const Timeline = () => {
  const [selectedGrade, setSelectedGrade] = useState("1-2");

  const timelineData = {
    "1-2": {
      title: "Early STEM Program",
      content: [
        "Prepare preschool and kindergarten students for school and life by building confidence and social skills while igniting their STEAM journey.",
        "LEGO based Early Learning tools inspire natural curiosity and encourage learning through play.",
        "Basic mechanical principles, such as gears, levers, pulleys, wheels, and axles, Simple machines.",
        "Investigating force, balance and unbalancing, fine motor skills, Problem solving through design",
        "STEM Integration",
        "Collaboration and fun",
      ],
      image: early, // Replace with actual image path
    },
    "3-5": {
      title: "Junior STEM Program",
      content: [
        "The 'Introducing Simple & Powered Machines' curriculum pack enables students to work as young scientists, engineers, and designers providing them with settings, tools and activities that promote engineering design, science and mathematics.",
        "Using mathematics and computational thinking.",
        "Constructing explanations (for science) and designing solutions (for engineering)",
        "Cause and Effect (Mechanism and explanation)",
      ],
      image: junior, // Replace with actual image path
    },
    "6-10": {
      title: "Senior STEM Program",
      content: [
        "From easy-entry lessons to the limitless creative designs, PEECEE Ai Kit engages students— regardless of their learning level—in thinking critically, analyzing data, and solving complex problems with real-world relevance.",
        "Students will apply their engineering design skills for each step of the design process by defining a problem and success criteria, making different prototypes, establishing systematic testing procedures, analyzing data to improve their solutions, and describing why a solution is the best.",
        "Students build Robots and Ai modules",
        "Use and understand the design process",
      ],
      image: senior, // Replace with actual image path
    },
    "8-12": {
      title: "ADVANCE EDU INDUSTRIAL ROBOTICS",
      content: [
        "Easy to build to make arms, legs, or anything else you dream up, 2 feet tall humanoid robot & Robotics arm & Robo spider",
        'Learning coding with "Drag and Drop" languages, like RoboScratch and Blockly, Python & JavaScript',
      ],
      image: advanced, // Replace with actual image path
    },
  };

  return (
    <section className={styles.timelineSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle} data-aos="fade-up">
          Comprehensive <span>STEM Programs</span>
        </h2>

        <div
          className={styles.timeline}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {Object.keys(timelineData).map((grade) => (
            <div
              key={grade}
              className={`${styles.timelineItem} ${
                selectedGrade === grade ? styles.active : ""
              }`}
              onClick={() => setSelectedGrade(grade)}
            >
              <span className={styles.gradeText}>Grade {grade}</span>
            </div>
          ))}
        </div>

        <div
          className={styles.contentSection}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className={styles.contentWrapper}>
            <h3 className={styles.programTitle}>
              {timelineData[selectedGrade].title}
            </h3>
            <div className={styles.contentLayout}>
              <div className={styles.textContent}>
                <ul>
                  {timelineData[selectedGrade].content.map((item, index) => (
                    <li
                      key={index}
                      data-aos="fade-right"
                      data-aos-delay={250 + index * 50}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.imageContent}
                data-aos="fade-left"
                data-aos-delay="300"
              >
                <img
                  src={timelineData[selectedGrade].image}
                  alt={`${timelineData[selectedGrade].title} illustration`}
                  className={styles.programImage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
